// extracted by mini-css-extract-plugin
export default {"header":"PageSidebar_header__u6zcz","footer":"PageSidebar_footer__fik0Z","itemLabelWithTag":"PageSidebar_itemLabelWithTag__pGxcc","betaTag":"PageSidebar_betaTag__PgjiV"};